import { createUseStyles } from '@glu/theming';

const direction = 'to right';

const styles = ({
  palette: {
    grey: { G400 },
    primary: { light, normal }
  },
  spacing: { unit },
  typography: {
    fontWeightMedium,
    mainTitle: { fontFamily },
    title: { fontSize }
  },
  widget: {
    controlIcon,
    separator: { direction: separatorDirection, gradientEnd, gradientStart, width }
  }
}) => ({
  widgetHeader: {
    alignItems: 'center',
    border: `solid ${G400}`,
    borderImage: `linear-gradient(${separatorDirection || direction}, ${gradientStart || light}, ${
      gradientEnd || normal
    }) 1`,
    borderWidth: `${width || `${unit / 2}px`} 0 0`,
    display: 'flex',
    justifyContent: 'space-between',
    padding: [unit * 3, 0],
    '& > h2': {
      fontSize,
      fontWeight: fontWeightMedium,
      fontFamily,
      textTransform: 'uppercase',
      marginBottom: 0
    },
    '& .icon-gear': {
      color: controlIcon.iconColor,
      fill: controlIcon.iconColor
    }
  }
});

export default createUseStyles(styles);
